import React from "react";

// Cinta horizontal de automatizaciones con scroll continuo — la lista se
// duplica una vez para que el loop (translateX(-50%)) quede sin costura.
export function EcoTicker({ items }) {
  const track = [...items, ...items];

  return (
    <div className="eco-ticker">
      <div className="eco-ticker__track">
        {track.map((item, i) => (
          <span className="eco-ticker__item" key={i}>
            <span className="eco-ticker__label">{item.label}</span>
            <span className="eco-ticker__value">{item.value}</span>
          </span>
        ))}
      </div>
    </div>
  );
}
